import React, { FC } from 'react';
import { MessageEntryAreaWithQuickActions } from './MessageEntryAreaWithQuickActions';
import { MessageEntryAreaWithoutQuickActions } from './MessageEntryAreaWithoutQuickActions';
import { MessageEntryAreaProps } from './props';

export const MessageEntryArea: FC<MessageEntryAreaProps> = ({
  message,
  metricsContext,
  onChange,
  onSend,
  onReject,
  onAccept,
  isDisabled,
  onClose,
  onReopen,
  messageThread,
}) => {
  if (messageThread.application?.id) {
    return (
      <MessageEntryAreaWithQuickActions
        isDisabled={isDisabled}
        message={message}
        messageThread={messageThread}
        metricsContext={metricsContext}
        onAccept={onAccept}
        onChange={onChange}
        onClose={onClose}
        onReject={onReject}
        onReopen={onReopen}
        onSend={onSend}
      />
    );
  }

  return (
    <MessageEntryAreaWithoutQuickActions
      isDisabled={isDisabled}
      message={message}
      messageThread={messageThread}
      metricsContext={metricsContext}
      onChange={onChange}
      onClose={onClose}
      onReopen={onReopen}
      onSend={onSend}
    />
  );
};
